// Bookmarks.js
import React, { useState, useEffect } from 'react';
import {
  View,
  Text,
  StyleSheet,
  FlatList,
  TouchableOpacity,
  SafeAreaView,
} from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';
import BookGridItem from './components/BookGridItem'; // Reuse from main component

const Bookmarks = () => {
  const navigation = useNavigation();
  const [bookmarkedBooks, setBookmarkedBooks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadBookmarks();
  }, []);

  const loadBookmarks = async () => {
    try {
      const bookmarks = await AsyncStorage.getItem('bookmarkedBooks');
      const allBooks = await AsyncStorage.getItem('engineeringBooks');
      
      if (bookmarks && allBooks) {
        const bookmarkedIds = JSON.parse(bookmarks);
        const books = JSON.parse(allBooks);
        const filteredBooks = books.filter(book => bookmarkedIds.includes(book.id));
        setBookmarkedBooks(filteredBooks);
      }
    } catch (error) {
      console.error('Error loading bookmarks:', error);
    } finally {
      setLoading(false);
    }
  };

  const renderEmptyState = () => (
    <View style={styles.emptyState}>
      <MaterialCommunityIcons name="bookmark-outline" size={64} color="#d1d5db" />
      <Text style={styles.emptyStateTitle}>No bookmarks yet</Text>
      <Text style={styles.emptyStateText}>
        Save books by tapping the bookmark icon
      </Text>
    </View>
  );

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.header}>
        <TouchableOpacity onPress={() => navigation.goBack()}>
          <MaterialCommunityIcons name="arrow-left" size={24} color="#1f2937" />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>Bookmarks</Text>
        <View style={{ width: 24 }} />
      </View>

      {bookmarkedBooks.length === 0 ? (
        renderEmptyState()
      ) : (
        <FlatList
          data={bookmarkedBooks}
          keyExtractor={(item) => item.id}
          renderItem={({ item }) => (
            <BookGridItem 
              book={item}
              onPress={() => navigation.navigate('BookPreview', { book: item })}
            />
          )}
          numColumns={2}
          contentContainerStyle={styles.listContainer}
        />
      )}
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#ffffff',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#e5e7eb',
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#1f2937',
  },
  emptyState: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 20,
  },
  emptyStateTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#1f2937',
    marginTop: 16,
    marginBottom: 8,
  },
  emptyStateText: {
    fontSize: 16,
    color: '#6b7280',
    textAlign: 'center',
  },
  listContainer: {
    padding: 16,
  },
});

export default Bookmarks;